'use strict';

var ad_content = function () {
  var self = this;

  self.init();
  self.bind();
};


ad_content.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_content');

  jQuery(document).arrive('.ad_content', function (localSelf) {
    localSelf.init_contents();
  }.bind(null, self));

};


ad_content.prototype.init = function () {
  var self = this;

  // console.log('init ad_content');

  self.init_contents();

};


ad_content.prototype.init_contents = function () {
  /*var self = this;*/

  // console.log('init ad_content');
  jQuery('.ad_content').each(
    function(/* index*/) {

      var element = jQuery(this);

      if (element.hasClass('st_mounted') === false) {
        // Acción Delete del menú de puntitos
        // element.on('ad_content.delete',
        //   function(event) {

        //     event.preventDefault();
        //     // event.stopPropagation();

        //     var id = jQuery(this).attr('id');

        //     console.log('Se ha disparado la acción de destruir el content con el id: ' + id);
        //     console.log('Aquí podríamos hacer una llamada AJAX al servidor para notificar que ha sido destruido.');

        //   }
        // );


        // Acción Duplicate del menú de puntitos
        // element.on('ad_content.duplicate',
        //   function(event) {

        //     event.preventDefault();
        //     event.stopPropagation();

        //     var id = jQuery(this).attr('id');

        //     console.log('Se ha disparado la acción de duplicar el content con el id: ' + id);

        //   }
        // );


        if ( element.hasClass('has_link') ) {

          var link = element.find('.ad_content_el_link');

          link.on(
              'click',
              function (event) {

                // console.log('event.target');
                // console.log(event.target);

                var url = null;

                if (jQuery(event.target).hasClass('ad_content_el_customLink') ) {

                  // console.log('has hecho click en un link normal');

                } else {
                  event.preventDefault();
                  event.stopPropagation();

                  url = jQuery(this).attr('data-href');

                }

                if (url !== null) {
                  // console.log('Vamos a ir a la url: ' + url);
                  window.location.href = url;
                }


              }
          );

        }

        element.addClass('st_mounted');
      }

    }
  );

};




jQuery( document ).ready(function() {

  window.ad_content = new ad_content();

});







